import {CircularProgress, TextField} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {getVocations} from 'app/services/location'
import _t, {_} from 'i18n'
import React, {useCallback, useEffect, useState} from 'react'

import {Column, Label, SelectedListContainer, SelectedListItem} from './styles'

const AutoCompleteVocations = ({selectedItem, onSelectItem, onRemoveItem, selectedItems}) => {
  const [activities, setActivities] = useState([])
  const [inputText, setInputText] = useState(selectedItem?.name ?? '')
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  selectedItems = selectedItems || []

  const getOptionLabel = ({description}) => `${description}`

  const onChange = (_, value) => {
    const isAdded = value?.description ? selectedItems.indexOf(value?.description) : false

    if (isAdded === -1 && value?.id) {
      onSelectItem(value.description)
      setInputText('')
    }
  }

  const onInputChange = (event) => {
    if (event) {
      setInputText(event.target?.value ? event.target?.value : '')
    }
  }

  const getOptionSelected = (option, value) => option.name === value.name

  const searchActivities = useCallback(async () => {
    setLoading(true)
    try {
      const data = await getVocations({limit: 50})

      setActivities(data.map((i, key) => ({description: i, id: key + 1})))
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    searchActivities()
  }, [searchActivities])

  return (
    <Column>
      <Label>{_`Vocação Regional`}</Label>
      <Autocomplete
        size="small"
        open={open}
        onOpen={() => {
          setOpen(true)
        }}
        onClose={() => {
          setOpen(false)
        }}
        getOptionSelected={getOptionSelected}
        getOptionLabel={getOptionLabel}
        options={activities}
        loading={loading}
        inputValue={inputText ? inputText : ''}
        noOptionsText={_`Nenhum item encontrado`}
        onChange={onChange}
        onInputChange={onInputChange}
        getOptionDisabled={(selected) =>
          selectedItems.indexOf(selected.description) !== -1 || selected === selectedItem
        }
        renderInput={(params) => (
          <TextField
            {...params}
            color="secondary"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              placeholder: _`Escolher…`,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      {selectedItems.length ? (
        <SelectedListContainer>
          {activities
            .filter(({id, description}) => selectedItems.indexOf(description) !== -1)
            .map(({id, description}) => (
              <SelectedListItem key={id}>
                {description}
                <i
                  className="far fa-times-circle"
                  style={{cursor: 'pointer'}}
                  onClick={() => onRemoveItem(description)}
                />
              </SelectedListItem>
            ))}
        </SelectedListContainer>
      ) : null}
    </Column>
  )
}

export default AutoCompleteVocations
